import { SET_SGIP_IS_VISIBLE } from './constants';

export const setSGIPIsVisible = isVisible => ({
    type: SET_SGIP_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/SGIP/actions.js